var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{name: 'status-check'}}},[_c('div',{class:['alert', 'article-preview', `alert-info`],attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_c('i',{staticClass:"el-icon-info"}),_vm._v(" "+_vm._s(_vm.$t('Here you can check the status of the application'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }